import { useParams, Link } from 'react-router-dom';
import { useEffect, useMemo, useState } from 'react';
import { FiArrowLeft, FiExternalLink } from 'react-icons/fi';
import api from '../lib/api';

const FALLBACK_IMG = 'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="1600" height="900"><defs><linearGradient id="g" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="%2314122a"/><stop offset="1" stop-color="%23201c3d"/></linearGradient></defs><rect width="100%" height="100%" fill="url(%23g)"/></svg>';

function fmt(n) {
    if (n === null || n === undefined || n === '') return '';
    const v = Number(n);
    if (Number.isNaN(v)) return String(n);
    return v % 1 === 0 ? String(v) : v.toFixed(2);
}

export default function GameDetail() {
    const { slug } = useParams();
    const [game, setGame] = useState(null);
    const [offers, setOffers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [offersLoading, setOffersLoading] = useState(true);
    const [cover, setCover] = useState(FALLBACK_IMG);

    useEffect(() => { setLoading(true); setOffersLoading(true); }, [slug]);

    useEffect(() => {
        if (!slug) return;
        api.get(`/game_detail?slug=${encodeURIComponent(slug)}`)
            .then(g => {
                setGame(g || null);
                const img = (g && g.image_url) ? g.image_url : FALLBACK_IMG;
                setCover(img);
            })
            .finally(() => setLoading(false));
    }, [slug]);

    useEffect(() => {
        if (!slug) return;
        setOffersLoading(true);
        api.get(`/prices?game=${encodeURIComponent(slug)}`)
            .then(d => setOffers(Array.isArray(d) ? d : []))
            .catch(() => setOffers([]))
            .finally(() => setOffersLoading(false));
    }, [slug]);

    const minText = useMemo(() => {
        if (!offers.length) return '—';
        let min = offers[0];
        for (const o of offers) if (Number(o.price) < Number(min.price)) min = o;
        const base = `${fmt(min.price)} ${min.currency || ''}`.trim();
        if (min.discount && Number(min.discount) > 0) return `${base} (−${min.discount}%)`;
        return base;
    }, [offers]);

    if (!game && loading) return <div className="gw-detail-loading">Načítám…</div>;
    if (!game) return (
        <div className="gw-detail-loading">
            <Link to="/" className="gw-link"><FiArrowLeft style={{verticalAlign:'-2px'}}/> Zpět</Link>
            <div className="gw-empty">Hra nenalezena</div>
        </div>
    );

    return (
        <div className="gw-detail">
            <div className="gw-cover-hero">
                <img src={cover} onError={()=>setCover(FALLBACK_IMG)} alt={game.name} />
                <div className="gw-cover-vignette" />
                <div className="gw-cover-meta">
                    <Link to="/" className="gw-link"><FiArrowLeft style={{verticalAlign:'-2px'}}/> Zpět</Link>
                    <h1 className="gw-detail-title">{game.name}</h1>
                    <div className="gw-detail-min">Nejlevněji {minText}</div>
                </div>
            </div>

            <div className="gw-offers">
                {offersLoading && Array.from({length:3}).map((_,i)=>(
                    <div key={'sk-'+i} className="gw-offer gw-offer-sk">
                        <div className="gw-offer-left">
                            <div className="sk-logo" />
                            <div className="sk-lines">
                                <div className="sk-line sk-w1" />
                                <div className="sk-line sk-w2" />
                            </div>
                        </div>
                        <div className="gw-offer-right">
                            <div className="sk-price" />
                            <div className="sk-cta" />
                        </div>
                    </div>
                ))}

                {!offersLoading && offers.map((o, i) => (
                    <a key={(o.shop || 'shop') + '-' + i + '-' + String(o.price)} href={o.url} target="_blank" rel="noreferrer" className="gw-offer">
                        <div className="gw-offer-left">
                            {o.shop_img && String(o.shop_img).trim() !== '' ? (
                                <img
                                    className="gw-shop-logo"
                                    src={o.shop_img}
                                    alt={o.shop}
                                    onError={(e)=>{e.currentTarget.style.display='none';}}
                                    style={{ width: 72, height: 'auto', objectFit: 'contain' }}
                                />
                            ) : (
                                <div className="gw-offer-shop" style={{fontSize:16, fontWeight:600}}>{o.shop}</div>
                            )}
                        </div>
                        <div className="gw-offer-right">
                            <div className="gw-price-row">
                                {o.discount && Number(o.discount) > 0 && (
                                    <span className="gw-badge-sale">−{Number(o.discount)}%</span>
                                )}
                                <div className="gw-price">
                                    {fmt(o.price)} {o.currency}
                                </div>
                            </div>
                            {o.old_price && Number(o.old_price) > Number(o.price) && (
                                <div className="gw-price-old">{fmt(o.old_price)} {o.currency}</div>
                            )}
                            <span className="gw-cta">Koupit <FiExternalLink style={{marginLeft:6,verticalAlign:'-2px'}}/></span>
                        </div>
                    </a>
                ))}

                {!offersLoading && !offers.length && <div className="gw-empty">Žádné nabídky</div>}
            </div>
        </div>
    );
}
